const SubscriptionStatuses = {
  FORMER_CLIENT: 'former_client',
  SUBSCRIBED: 'subscribed',
};

export default SubscriptionStatuses;
